// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { alertService } from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {
  getJenisPetugas,
  insertjenispetugas,
  jenispetugasSelector,
  updatejenispetugas,
} from "./jenispetugasSlice";

import { Colors } from "../../../assets/Colors";
import { maxPageGlobal } from "../../../assets/config";

const JenispetugasPage = ({}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [firstLoading, setFirstLoading] = useState(false);
  const [start, setStart] = useState(0);
  const [count, setCount] = useState(maxPageGlobal);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [search, setSearch] = useState("");
  const [searchFetch, setSearchFetch] = useState(false);
  const [insertFetch, setInsertFetch] = useState(false);
  const [updateFetch, setUpdateFetch] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [currentData, setCurrentData] = useState({});

  const jenispetugas = useSelector(jenispetugasSelector);

  useEffect(() => {
    dispatch(
      getJenisPetugas({
        start: start,
        count: count,
        search: "",
      })
    );
  }, []);

  useEffect(() => {
    if (
      search !== "" &&
      jenispetugas.isGetSuccess &&
      !jenispetugas.isGetFetching
    ) {
      let calc = jenispetugas?.count - 1;
      if (calc === 0) {
        calc = 1;
      }

      if (calc % count === 0) {
        calc = calc + 1;
      }
      let tempMaxPage = jenispetugas.data ? Math.ceil(calc / count) : 1;
      setSearchFetch(false);
      setMaxPage(tempMaxPage);
    } else if (
      search === "" &&
      jenispetugas.isGetSuccess &&
      !jenispetugas.isGetFetching
    ) {
      let calc = jenispetugas?.count - 1;
      if (calc === 0) {
        calc = 1;
      }

      if (calc % count === 0) {
        calc = calc + 1;
      }
      let tempMaxPage = jenispetugas.data ? Math.ceil(calc / count) : 1;
      setSearchFetch(false);
      setMaxPage(tempMaxPage);
    }

    if (
      !jenispetugas?.isGetFetching &&
      jenispetugas.isGetSuccess &&
      maxPage === 0 &&
      firstLoading === false
    ) {
      let calc = jenispetugas?.count - 1;
      if (calc === 0) {
        calc = 1;
      }

      if (calc % count === 0) {
        calc = calc + 1;
      }
      let tempMaxPage = jenispetugas.data ? Math.ceil(calc / count) : 1;
      setMaxPage(tempMaxPage);
      setFirstLoading(true);
      dispatch(
        getJenisPetugas({
          start: start,
          count: count,
          search: search,
        })
      );
    }

    if (insertFetch) {
      setInsertFetch(false);
      if (jenispetugas.isGetSuccess) {
        alertService.success(jenispetugas.message, {
          autoClose: true,
          keepAfterRouteChange: false,
        });
        dispatch(
          getJenisPetugas({
            start: start,
            count: count,
            search: search,
          })
        );
      }
    }

    if (updateFetch) {
      setUpdateFetch(false);
      if (jenispetugas.isUpdateSuccess) {
        alertService.success(jenispetugas.message, {
          autoClose: true,
          keepAfterRouteChange: false,
        });
        dispatch(
          updatejenispetugas({
            start: start,
            count: count,
            search: search,
          })
        );
      }
    }
  });

  // function handlegetJenisPetugas(params) {
  //   return dispatch(getJenisPetugas(params));
  // }

  function handleInsertJenisPetugas(param) {
    setInsertFetch(true);
    const params = {
      jenisPetugas: param.inputOneValue,
    };
    dispatch(insertjenispetugas(params));
  }

  function handleUpdateJenisPetugas(param) {
    setUpdateFetch(true);

    const params = {
      jenisPetugas: param.inputOneValue,
      ID: currentData.ID,
    };

    dispatch(updatejenispetugas(params));
  }

  function handleSearch(searchValue) {
    let params = {
      start: 0,
      count: 5,
      search: searchValue,
    };
    dispatch(getJenisPetugas(params));

    setStart(0);
    setCount(5);
    setSearch(searchValue);
    setSearchFetch(true);
  }

  function handleUpdatePage(newPage) {
    let newStart = newPage * count - count;

    let params = {
      start: newStart,
      count: count,
      search: search,
    };
    dispatch(getJenisPetugas(params));

    setPage(newPage);
    setStart(newStart);
  }

  function handleUpdateCount(newCount) {
    let calc = jenispetugas.count - 1;
    if (calc === 0) {
      calc = 1;
    }

    let params = {
      start: newCount === "-1" ? 0 : start,
      count: newCount === "-1" ? jenispetugas.count : newCount,
      search: search,
    };
    dispatch(getJenisPetugas(params));

    setPage(1);
    setCount(newCount === "-1" ? jenispetugas.count : newCount);
    setStart(newCount === "-1" ? 0 : start);
    setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
  }

  function handleCurrentData(values) {
    setCurrentData(values);
  }

  function handleModal(status) {
    setShowModalAdd(status.showModalAdd);
    setShowModalEdit(status.showModalEdit);
  }

  if (!firstLoading) {
    return <div>loading</div>;
  } else {
    return (
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>

        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <TableCard
                backButton={true}
                backUrl={"master"}
                handleSearch={handleSearch}
                searchPlaceholder="Petugas"
                updatePage={handleUpdatePage}
                updateCount={handleUpdateCount}
                currentData={handleCurrentData}
                currentPage={page}
                maxPage={maxPage}
                tableTitle="Master Petugas"
                tableData={jenispetugas.data}
                colOneTitle="ID"
                colOneData="ID"
                colTwoTitle="Jenis Petugas"
                colTwoData="JenisPetugas"
                fetching={jenispetugas.isGetFetching}
                modal={handleModal}
                editEnabled={true}
              />
            </div>
          </div>
        </div>
        {showModalAdd && (
          <ModalForm
            showModal={showModalAdd}
            // addEnabled={true}
            modal={handleModal}
            modalTitle="Tambah Jenis Petugas"
            inputOneTitle="Nama Jenis Petugas"
            inputOnePlaceholder=""
            submitButtonTitle="Submit"
            handleSubmit={handleInsertJenisPetugas}
          />
        )}
        {showModalEdit && (
          <ModalForm
            showModal={showModalEdit}
            // editEnabled={true}
            id={currentData.ID}
            modal={handleModal}
            modalTitle="Ubah Petugas"
            inputOneTitle="Jenis Petugas"
            inputOneValue={currentData.JenisPetugas}
            submitButtonTitle="Submit"
            handleSubmit={handleUpdateJenisPetugas}
          />
        )}
      </div>
    );
  }
};

export default JenispetugasPage;
